import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import { useModuleEnabled } from "../../../redux/selectors/modules";

export const useBiddingPrograms = () => {
  const hasMultiOrgRulesModuleEnabled = useModuleEnabled("MULTI_ORG_RULES");
  return useQuery({
    queryKey: ["bidding_programs"],
    queryFn: async () =>
      await apiClient.getBiddingPrograms({
        queries: { all_user_orgs: hasMultiOrgRulesModuleEnabled },
      }),
  });
};
